@use '../../styles/util' as *;
@use '../../styles/global' as *;

:host {
  display: block;
}

.sol-breadcrumb {
  display: flex;
  padding-left: 0;
  margin: 0;
  list-style: none;
}
